import { TravailStubPage } from '../../../../components/parcours/TravailStubPage';
import { getTravailStub } from '../../../../config/travaux-particuliers';

export default function IsolationSolsPage() {
  const travail = getTravailStub('isolation-sols');
  if (!travail) return null;
  return <TravailStubPage travail={travail} />;
}
